/**
 * Набор методов для работы с UTM метками
 * - сохранение UTM из URL в localStorage
 * - заполнение объекта FormData UTM метками
 */

if(!window.utmHandlers) {
  window.utmHandlers = initUtmHandlers();
  window.addEventListener('load', () => {
    window.utmHandlers.saveUtmTags();
  })
}


function initUtmHandlers() {
  return {

    /**
     * Заполнить UTM метки в объект FormData
     * @param formData {FormData}
     * @param nestedField {string|null} - вложенное поле
     */
    fillFormUtm(formData, nestedField = null) {
      const utmTags = this.getUtmTags();
      Object.keys(utmTags).map(tag => {
        if(tag.toUpperCase().startsWith('UTM_')) {
          let field = tag.toUpperCase();
          if(nestedField) field = `${nestedField}[${field}]`; // @example request[UTM_SOURCE]

          formData.append(field, utmTags[tag]);
        }
      })

      return formData;
    },

    /**
     * Сохранить UTM метки из URL в localStorage
     */
    saveUtmTags() {
      const queryString = window.location.search;
      const queryParams = new URLSearchParams(queryString);

      const params = Object.fromEntries(queryParams);
      const utmKeys = Object.keys(params).filter(key => key.toUpperCase().startsWith('UTM_'));

      const utmTags = Object.fromEntries(
        utmKeys.map(key => [key.toUpperCase(), params[key]])
      );

      // save into localStorage
      if(Object.values(utmTags).length)
        localStorage.setItem(this._getStorageField(), JSON.stringify(utmTags));
    },

    /**
     * Получить сохраненные метки из localStorage
     * @returns {any}
     */
    getUtmTags() {
      try {
        const storedStr = localStorage.getItem(this._getStorageField());
        const storedData = JSON.parse(storedStr);
        if(!storedData || Array.isArray(storedData) || typeof storedData !== 'object')
          return {};

        return storedData;
      } catch (e) {
        console.error('Error on get UTM tags', e.message || 'unknown error');
        return {};
      }
    },

    /**
     * Добавляет скрытые поля в форму для отправки UTM меток
     * @param form {HTMLFormElement}
     * @param nestedField {string|null} - вложенное поле
     */
    appendFormUtmInputs(form, nestedField = null) {

      if(!form || !(form instanceof HTMLFormElement))
        return;

      const utmTags = this.getUtmTags();
      const utmKeys = Object.keys(utmTags);

      if(!utmKeys.length)
        return;

      for(let utmKey of utmKeys){

        if(nestedField)
          utmKey = `${nestedField}[${utmKey}]`; // @example request[UTM_SOURCE]

        const input = form.querySelector(`[name="${utmKey}"]`);
        if(input) continue;

        const elem = document.createElement('input');
        elem.type = 'hidden';
        elem.name = utmKey;
        elem.value = utmTags[utmKey];

        form.appendChild(elem);
      }
    },


    /**
     * Поле localStorage
     * @private
     * @returns {string}
     */
    _getStorageField() {
      return 'utm_tags';
    },
  };
}